import React, {useState, useEffect, useRef, useContext, useMemo} from 'react';
import { Radio, Upload, Checkbox, Popover, Empty, Modal, message, Image, Spin } from 'antd';
import Utils from '@utils/utils'
import API from '@api/api'
import ModelFilterSelect from '@view/compoents/modelFilterSelect/modelFilterSelect';
import MoreScenePopoverContent from '@view/compoents/MoreScenePopoverContent/MoreScenePopoverContent'
import { AppContext } from '@utils/AppContext';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import styles from './selectModel.module.scss'
import { CLOTHES_SUBTYPE, CLOTH_TYPE } from "@utils/CONST"
import exampleJSON from '@assets/custom_model_example/example.json'
import { GenerateContext } from "@utils/GenerateContext"
import PSAIModal from '@PSAIComponents/PSAIModal';

const SceneItem = (props) => {
    const {scene, selectedImg, selectImgClick, onMoreSceneChange} = props
    const [moreSceneModalOpen, setMoreSceneModalOpen] = useState(false)

    const selectSceneClick = () => {
        if (scene?.subList && scene?.subList.length > 0) {
            setMoreSceneModalOpen(true)
            selectImgClick(scene, scene.attr?.version)
        } else {
            selectImgClick(scene, scene.attr?.version)
        }
    }

    const onChange = (...args) => {
        onMoreSceneChange(scene.id, ...args)
        setMoreSceneModalOpen(false)
    }

    const onOpenChange = (value) => {
        if (!value) setMoreSceneModalOpen(false)
    }



    const formartTitle = (title, poseType) => {
        if(props.isposeType == 'pose') {
            // if(poseType == 1) return <p className={styles.scene_title}>半身</p>
            // else return <p className={styles.scene_title}>全身</p>
        } else {
            const arr = title?.split('-')
            return title && <p className={styles.scene_title}>{arr.length > 0 ? arr[arr.length - 1] : title}</p>
        }
        
    }

    return (
        <Popover
            placement="topLeft"
            content={<MoreScenePopoverContent tryOn={props.tryOn} sceneList={scene?.subList} selectedName={selectedImg} onChange={onChange}/>}
            open={moreSceneModalOpen}
            arrow={false}
            overlayInnerStyle={{ padding: 0 }}
            trigger={"click"}
            onOpenChange={onOpenChange}
        >
            <div onClick={selectSceneClick} className={`${styles.sceneItem} ${selectedImg==scene.name && styles.selectedImg} ${props.tryOn && styles.tryOn}`}>
                <div className={styles.sceneItemImg}>
                    <Image
                        width={"100%"}
                        height={"100%"}
                        style={{objectFit: 'cover'}}
                        preview={false}
                        src={`${Utils.addVersionParamToURL(scene.imageUrl, 'v', scene?.attr?.version)}&x-oss-process=image/format,webp`}
                    />
                </div>
                {
                    formartTitle(scene?.attr?.title, scene?.attr?.poseType)
                }
                {scene.attr.recent == 1?<i className={styles.new_icon}></i>: null}
                {
                    scene.subList?.length > 0 &&
                    <div className={styles.more_scene_handler}>
                        <i className={styles.more_scene_handler_img}></i>
                    </div>
                }
                {
                    scene.attr.skin == 'custom' &&
                    <div className={styles.RemoveTrigger} onClick={() => props.onRemove(scene)}><DeleteOutlined /></div>
                }
            </div>
        </Popover> 
    )
}

const SelectModel = (props) => {
    const { isProEnv, globalModelFilter, filteredModelListRef, setModelList,  setPoselList} = useContext(AppContext);
    const { imageType, keepPose, setKeepPose } = useContext(GenerateContext);
    

    const [selectedImg, setSelectedImg] = useState();
    const orginModelLibRef = useRef([])
    const [loading, setLoading] = useState(true)
    const [modelLib, setModelLib] = useState([]);
    const [once, setOnce] = useState(true)

    const [skin, setSkin] = useState([...globalModelFilter?.skin || []]);
    const [sex, setSex] = useState([...globalModelFilter?.sex || []]);
    const [age, setAge] = useState([...globalModelFilter?.age || []]);
    const [type, setType] = useState([]);


    const [update, forceUpdate] = useState({})
    const versionRef = useRef()


    useEffect(() => {
        setSkin([...globalModelFilter?.skin || []])
        setSex([...globalModelFilter?.sex || []])
        setAge([...globalModelFilter?.age || []])
    }, [globalModelFilter])

    useEffect(() => {
        if(props.tryOn == 'null') return
        setLoading(true)
        const getModelApi = props.isposeType == 'pose' ? API.modelTryOnList : API.modelPersonList
        const promise = props.isposeType == 'pose' ?
        getModelApi({
            // age: age.join(),
            sex: sex.join()
        }) :
        getModelApi({
            age: age.join(),
            sex: sex.join(),
            skin: skin.join(),
            type: type.join(),
            imageType: imageType
        })
        promise.then((res) => {
            if(res.code == 0) {
                if (res.data.length == 0) {
                    setModelLib([])
                    orginModelLibRef.current = []
                    return
                }
                let resList = [...res.data]
                if(props.isposeType == 'pose') {
                    setPoselList(resList)
                } else {
                    setModelList(resList)
                }
                // 得到version
                for (let i = 0; i < resList.length; i++) {
                    const item = resList[i]
                    if (item.attr?.version) versionRef.current = item.attr?.version
                }
                orginModelLibRef.current = JSON.parse(JSON.stringify(resList))
                // tryon支持用户上传自定义模特
                // let arr = Utils.chunkArray(props.tryOn ? [{upload: true}, ...resList] : resList, 6)
                let arr = props.tryOn ? [{upload: true}, ...resList] : resList
                const firstItem = props.isposeType === 'pose'?resList[0]: resList[1] // 默认选择第一个
                let isSelfDefined = firstItem.attr.skin == 'custom'
                let selfDefinedImg = firstItem.attr.tryOnImage
                let name = firstItem.name
                const showIndex = imageType == 'model' || imageType == 'dressform'? 9: props.isposeType == 'tyronModel'? 6: 1

                if (props.modelName) {
                    setOnce(false);
                    const hasName = arr.some(item => item.name === props.modelName)
                    if(hasName) name = props.modelName;
                    let found = false;
                    let indexToReplace = -1; // 初始化要替换的项的索引为-1
                  
                    // 检查前6个元素是否包含 props.modelName 对应的项
                    for (let i = 0; i < Math.min(arr.length, showIndex); i++) {
                      if (arr[i].name === name) {
                        found = true;
                        break;
                      }
                    }
                  
                    if (!found) {
                      // 查找数组中 props.modelName 对应的项，并记录索引
                      for (let i = 0; i < arr.length; i++) {
                        if (arr[i].name === name) {
                          indexToReplace = i;
                          break;
                        }
                        if (arr[i].subList) {
                          let subList = arr[i].subList;
                          for (let j = 0; j < subList.length; j++) {
                            if (subList[j].name === name) {
                              indexToReplace = i;
                              break;
                            }
                          }
                        }
                        if (indexToReplace !== -1) {
                          break;
                        }
                      }
                    }
                  
                    if (indexToReplace !== -1) {
                      // 将找到的项替换到数组下标1的位置
                      const temp = arr[1];
                      arr[1] = arr[indexToReplace];
                      arr[indexToReplace] = temp;
                  
                      if(once) props.foundModelFunc && props.foundModelFunc();
                    } else {
                      name = name;
                      if(once) props.notFoundModelFunc && props.notFoundModelFunc();
                    }
                }
                setModelLib(arr)

                setSelectedImg(name)
                props.getSelectModal(props.isposeType == 'pose'? 'Pose': 'Model', name, versionRef.current, isSelfDefined, selfDefinedImg)
            }
        }).catch((error) => {
            console.log(error)
        }).finally(() => {
            setLoading(false)
        })
    }, [skin, sex, age, type, update, props.refreshRecent]);

    const carouselRef = useRef()

    useEffect(() => {
        if (props.isposeType == 'pose') return
        if (!age || age.length == 0) {
            // 不特意删选时，随机模特过滤掉儿童
            filteredModelListRef.current = modelLib.flat()
                .filter(item => !item.upload && item?.attr?.age != 'children' && !/_default_style$/.test(item.name))
                .map(item => [item.name, ...item.subList.map(i => i.name)])
                .flat()
        } else {
            filteredModelListRef.current = modelLib.flat()
                .filter(item => !item.upload && !/_default_style$/.test(item.name))
                .map(item => [item.name, ...item.subList.map(i => i.name)])
                .flat()
        }
    }, [modelLib, age, props.isposeType])

    const onMoreSceneChange = (id, name, url, version) => {
        const arr = [...modelLib]
        let found = false
        for (let item of arr) {
            if (item.id == id) {
                item.name = name
                item.imageUrl = url
                found = true
                break
            }
            if (found) break
        }
        setModelLib(arr)
        setSelectedImg(name)
        props.getSelectModal(props.isposeType == 'pose'? 'Pose': 'Model', name, version)
    }

    const selectImgClick = (item, version) => {
        setSelectedImg(item.name)
        const isSelfDefined = item.attr.skin == 'custom'
        const selfDefinedImg = item.attr.tryOnImage
        props.getSelectModal(props.isposeType == 'pose'? 'Pose': 'Model', item.name, version || versionRef.current, isSelfDefined, selfDefinedImg )
        checkDrawerSelect(item)
    }

    const selectRandom = () => {
        selectImgClick(modelLib[0], modelLib[0].attr.version)
    }

    const selectModalSave = (item, version) => {
        const arr = [...modelLib]
        let found = false
        for (let item2 of arr) {
            if (item2.id == item.id) {
                item2.name = item.name
                item2.imageUrl = item.imageUrl
                found = true
                break
            }
            if (found) break
        }
        setModelLib([...arr])
        selectImgClick(item, version)
    }

    useEffect(() => {
        if(props.drawerSaveSelect.length == 0) return
        selectModalSave(props.drawerSaveSelect[0], props.drawerSaveSelect[1])
    }, [props.drawerSaveSelect])

    const checkDrawerSelect = (select) => {
        // 展示模特没有替换第一个
        // 这两个数字可以根据props.tryOn 调整
        let showLength = props.tryOn?isProEnv?3:2: props.isposeType == 'tyronModel'?6: 9
        let replaceIndex = 1
        let slicedArray = modelLib.slice(0, showLength);
        let itemExists = slicedArray.some(item => item.name === select.name);
        if (!itemExists) {
            let arr = [...modelLib]
            arr[replaceIndex] = select
            setModelLib(arr)
        }
    }

    const beforeUpload = async (file) => {
        try {
            const url = await Utils.uploadFile(file)
            if (!url) return false
            const res2 = await API.saveCustomTryOnModel({
                tryOnImage: url,
                thumbnail: url,
            })
            if (res2?.code != 0) throw new Error(res2?.message)
            message.success('添加成功')
            props.checkIsUploadModel(url)
            setOpen(false)
            forceUpdate({})
        } catch (err) {
            message.warning(err.message)
        } finally {
            return false
        }
    }

    const onRemove = (item) => {
        PSAIModal.confirm({
            title: '确定删除这个自定义模特吗？',
            onOk() {
                API.removeCustomTryOnModel({
                    id: item.id
                }).then(res => {
                    if (res?.code != 0) return message.warning(res?.message)
                    message.success('删除成功')
                    props.checkIsUploadModel()
                    forceUpdate({})
                })
            },
        })
    }

    const [open, setOpen] = useState()
    const onImgRequire = (e) => {
        e.stopPropagation()
        setOpen(true)
    }

    useEffect(() => {
        props.getDrawerDate(selectedImg)
    }, [selectedImg])

    const modelRandomChange = (e) => {
        if(selectedImg == '00_default_style') return
        selectImgClick(modelLib[0], modelLib[0].attr.version)
    };

    return (
        <div className={styles.SelectModel}>
            <div className={styles.select_title}>
                <span>{props.isposeType == 'pose'? '选择姿势': '选择模特'}</span> 
                {isProEnv ? null : (props.isposeType == 'pose' && <Checkbox checked={keepPose} onChange={e => setKeepPose(e.target.checked)}>保持模特不变</Checkbox>)}
                {!props.tryOn && <Checkbox checked={selectedImg == '00_default_style'? true: false} onChange={modelRandomChange}>随机</Checkbox>}
            </div>
            {/* {
                props.isposeType != 'pose'&&<ModelFilterSelect
                selectRandom={selectRandom}
                selectedImg={selectedImg}
                tryOn={props.tryOn}
                />
            } */}
            
            <div className={styles.model_select_img}>
                {
                    !loading &&
                    modelLib.length>0?
                        <div className={styles.scene_select_img_box}>
                            {
                                modelLib.map((item2, index) => {
                                    if(index > (props.tryOn?isProEnv?2: 1: props.isposeType == 'tyronModel'?5: 8)) return
                                    if (item2.upload && props.isposeType == 'pose') {
                                        return (
                                            isProEnv?null: <Upload
                                                key="upload"
                                                className={`${styles.sceneItem} ${styles.uploadWrap} ${props.tryOn && styles.tryOn}`}
                                                accept='image/jpeg,image/png,image/webp,image/avif'
                                                showUploadList={false}
                                                beforeUpload={beforeUpload}
                                            >
                                                <div
                                                    className={[
                                                        styles.addTrigger,
                                                        props.tryOn && styles.tryOn,
                                                    ].join(' ')}
                                                >
                                                    <div className={styles.addTriggerContent}>
                                                        <UploadOutlined />
                                                        <p>上传姿势图</p>
                                                        <p onClick={onImgRequire}>图片要求</p>
                                                    </div>
                                                </div>
                                            </Upload>
                                        )
                                    } else if(item2.name != '00_default_style') {
                                        return (
                                            <SceneItem
                                                tryOn={props.tryOn}
                                                key={item2.id}
                                                scene={item2}
                                                selectedImg={selectedImg}
                                                selectImgClick={selectImgClick}
                                                onMoreSceneChange={onMoreSceneChange}
                                                onRemove={onRemove}
                                                isposeType={props.isposeType}
                                            />
                                        )
                                    }
                                   
                                })
                            }
                            {
                                modelLib.length > 0 &&
                                <div className={`${props.tryOn? styles.moreItem_tryon: styles.moreItem} more_btn`}  
                                onClick={(e) => props.toggleDrawer(e, props.isposeType == 'pose'?'Pose': 'Model')}><p>更多 <i></i></p></div>
                            }
                        </div>: null
                }
                { loading && <div className={styles.empty_wrap}><Spin /></div> }
                { !loading && modelLib.length == 0 && <div className={styles.empty_wrap}><Empty /></div> }
            </div>
            <PSAIModal
                title={"图片要求"}
                open={open}
                maxWidth={850}
                footer={null}
                onCancel={() => setOpen(false)}
            >
                <div className={styles.UploadExample}>
                    <div>
                        <p className={styles.UploadExampleTitle}>正确示例</p>
                        <div className={styles.UploadExampleList}>
                        {exampleJSON.correct_list.map(item => (
                            <div key={item.value} className={styles.UploadExampleItem}>
                                <div>
                                    <img src={require(`@assets/custom_model_example/${item.value}`)} />
                                    <img src={require('@assets/images/accurate.png')} alt="" />
                                </div>
                                <p>{item.label.split('\r\n').map(item => <span key={item}>{item}<br/></span>)}</p>
                            </div>
                        ))}
                        </div>
                    </div>
                    <div>
                        <p className={styles.UploadExampleTitle}>错误示例</p>
                        <div className={styles.UploadExampleList}>
                        {exampleJSON.incorrect_list.map(item => (
                            <div key={item.value} className={styles.UploadExampleItem}>
                                <div>
                                    <img src={require(`@assets/custom_model_example/${item.value}`)} />
                                    <img src={require('@assets/images/incorrect.png')} alt="" />
                                </div>
                                <p>{item.label.split('\r\n').map(item => <span key={item}>{item}<br/></span>)}</p>
                            </div>
                        ))}
                        </div>
                    </div>
                </div>
            </PSAIModal>
        </div>
    )
}

export default SelectModel